<template>
  <div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';

export default {
  mounted() {
    const isHandlerEnabled = (config={}) => {
      return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ?
        false : true;
    };

    const errorHandler = async (error) => {
      if (isHandlerEnabled(error.config)) {
        if(error && error.response && error.response.status === 401) {
          this.$store.dispatch('auth/hardSignOut');
          if(this.$router.currentRoute.fullPath !== '/') {
            this.$store.dispatch('auth/setRedirectUrl', this.$router.currentRoute.fullPath );
            this.$router.push(`/`,  () => {
              // setTimeout(() => {
              //   this.$bvToast.toast("Your session has expired, please log in again.");
              // }, 500);
            });
          }
        }
      }
      return Promise.reject({ ...error })
    };

    const successHandler = (response) => {
      if (isHandlerEnabled(response.config)) {
        // Handle responses
      }
      return response;
    };

    axios.interceptors.response.use(
      response => successHandler(response),
      async error => await errorHandler(error)
    )
  },
};
</script>

<style>

</style>
